// src/constants/speciesTypes.js
// The species TYPE vocabulary — a declared mirror of facility/enums.py
// (AnimalTypes, ANIMAL_TYPE_LABELS, STOREFRONT_SPECIES_TYPES).
//
// I-03 close 1c (operator 2026-10-24): "A dragon is not a gecko." REPTILE
// (4, "Other reptile") is every reptile that is not a gecko. It has NO
// storefront category, nav menu or shop page — its species reach customers
// only through their care guides — so it is deliberately absent from
// STOREFRONT_SPECIES_TYPES.

export const SPECIES_TYPE = {
  FROG: 0,
  PLANT: 1,
  AQUATIC: 2,
  GECKO: 3,
  REPTILE: 4,
};

export const SPECIES_TYPE_LABELS = {
  [SPECIES_TYPE.FROG]: 'Frog',
  [SPECIES_TYPE.PLANT]: 'Plant',
  [SPECIES_TYPE.AQUATIC]: 'Aquatic',
  [SPECIES_TYPE.GECKO]: 'Gecko',
  [SPECIES_TYPE.REPTILE]: 'Other reptile',
};

// I-03 close 1c: an Other reptile is NEVER sold here, whatever its stored
// flag (facility/services/species_selling.never_sold_types). The species
// editors lock the "Not sold here" box for one and print this beside it.
export const REPTILE_NEVER_SOLD_REASON = 'Other reptiles are kept, never sold here.';

// The types a CUSTOMER may browse as a category. REPTILE is not one.
export const STOREFRONT_SPECIES_TYPES = [
  SPECIES_TYPE.FROG, SPECIES_TYPE.PLANT, SPECIES_TYPE.AQUATIC, SPECIES_TYPE.GECKO,
];

export const isStorefrontSpeciesType = (t) => {
  const n = t === null || t === undefined || t === '' ? NaN : Number(t);
  return STOREFRONT_SPECIES_TYPES.includes(n);
};

/**
 * The word a dropdown prints for one /facility/animal-types/ row: the
 * server's `label` ("Other reptile"), else our own label for its id, else
 * the enum NAME — never the raw NAME when a label is known.
 */
export const animalTypeLabel = (type) => {
  if (!type) return '';
  if (type.label) return type.label;
  const own = SPECIES_TYPE_LABELS[Number(type.id)];
  return own || String(type.name || '');
};

// The grids' Species Type filter options. The VALUE is the enum NAME — the
// server resolves it with AnimalTypes[s.upper()] (facility/views.py
// _species_type_value), so it must stay a single-token name.
export const SPECIES_TYPE_FILTER_OPTIONS = [
  { value: 'FROG', label: 'Frog' },
  { value: 'PLANT', label: 'Plant' },
  { value: 'GECKO', label: 'Gecko' },
  { value: 'REPTILE', label: 'Other reptile' },
  { value: 'AQUATIC', label: 'Aquatic' },
];
